"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _polished = require("polished");

var _interpolateDefaultRequire = _interopRequireDefault(require("../../utils/interpolateDefaultRequire"));

var _constants = require("../../components/theme/constants");

var _inputStates, _enabled;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var branding = {
  favIconName: 'favicon-stir',
  name: 'stir'
}; //                 0  1  2   3   4   5   6   7   8   9  10  11  12  13  14  15  16

var iconScale = [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64];
var space = {
  none: 0,
  xsmall: 4,
  small: 8,
  smedium: 12,
  medium: 16,
  large: 20,
  xlarge: 24,
  xxlarge: 32,
  xxxlarge: 40
};
var iconSizes = {
  xxsmall: iconScale[2],
  // 8
  xsmall: iconScale[4],
  // 16
  small: iconScale[6],
  //24
  medium: iconScale[8],
  //32
  large: iconScale[10],
  //40
  xlarge: iconScale[12],
  //48
  xxlarge: iconScale[14],
  ///56
  xxxlarge: iconScale[16] // 64

};
var fontSizes = {
  xxxsmall: 11,
  xxsmall: 12,
  xsmall: 14,
  small: 16,
  medium: 18,
  large: 20,
  xlarge: 28,
  xxlarge: 32,
  xxxlarge: 36,
  xxxxlarge: 40
};

var fontVariants = function fontVariants() {
  return [{
    family: 'Beausite Classic',
    url: require('./static/fonts/beausite-classic-clear.woff2'),
    weight: '400',
    format: 'woff2'
  }, {
    family: 'Beausite Classic',
    url: require('./static/fonts/beausite-classic-clear-semibold.woff2'),
    weight: '500 700',
    format: 'woff2'
  }];
};

var font = {
  monospace: "'Courier New', Courier, monospace",
  heading: "'Source Serif Pro', 'Times New Roman', Times, serif",
  body: "'Beausite Classic', Helvetica, Arial, sans-serif"
};
var lineHeights = {
  xxxsmall: '12px',
  xxsmall: '14px',
  xsmall: '16px',
  small: '20px',
  medium: '24px',
  large: '30px',
  xlarge: '34px',
  xxlarge: '38px',
  xxxlarge: '44px'
};
var typography = {
  heading1: {
    fontFamily: _constants.FONT_FACE.HEADING,
    fontSize: fontSizes.xxxxlarge,
    letterSpacing: '-1px',
    lineHeight: lineHeights.xxxlarge,
    fontWeight: _constants.FONT_WEIGHT.BOLD,
    paddingBottom: '5px'
  },
  heading2: {
    fontFamily: _constants.FONT_FACE.HEADING,
    fontSize: fontSizes.xxxlarge,
    fontWeight: _constants.FONT_WEIGHT.BOLD,
    letterSpacing: '-0.25px',
    lineHeight: lineHeights.xxlarge,
    paddingBottom: '5px'
  },
  heading3: {
    fontFamily: _constants.FONT_FACE.HEADING,
    fontSize: fontSizes.xxlarge,
    letterSpacing: '-0.4px',
    lineHeight: lineHeights.xlarge,
    fontWeight: _constants.FONT_WEIGHT.BOLD,
    paddingBottom: '4px'
  },
  heading4: {
    fontFamily: _constants.FONT_FACE.HEADING,
    fontSize: fontSizes.xlarge,
    letterSpacing: '-0.5px',
    lineHeight: lineHeights.large,
    paddingBottom: '2px',
    fontWeight: _constants.FONT_WEIGHT.BOLD
  },
  heading5: {
    fontFamily: _constants.FONT_FACE.HEADING,
    fontSize: 24,
    letterSpacing: '-0.5px',
    lineHeight: lineHeights.large,
    paddingBottom: '1px',
    fontWeight: _constants.FONT_WEIGHT.BOLD
  },
  heading6: {
    fontFamily: _constants.FONT_FACE.HEADING,
    fontSize: fontSizes.large,
    letterSpacing: '-0.1px',
    lineHeight: lineHeights.medium,
    paddingBottom: '3px',
    fontWeight: _constants.FONT_WEIGHT.BOLD
  },
  heading7: {
    fontFamily: _constants.FONT_FACE.BODY,
    fontSize: fontSizes.small,
    letterSpacing: '0px',
    lineHeight: lineHeights.small,
    fontWeight: _constants.FONT_WEIGHT.BOLD
  },
  heading7b: {
    fontFamily: _constants.FONT_FACE.HEADING,
    fontSize: fontSizes.small,
    letterSpacing: '0px',
    lineHeight: lineHeights.small,
    fontWeight: _constants.FONT_WEIGHT.BOLD
  },
  heading8: {
    fontFamily: _constants.FONT_FACE.HEADING,
    fontSize: fontSizes.xxsmall,
    letterSpacing: '0px',
    lineHeight: lineHeights.xsmall,
    fontWeight: _constants.FONT_WEIGHT.BOLD
  },
  largeBody: {
    fontFamily: _constants.FONT_FACE.BODY,
    fontSize: fontSizes.large,
    lineHeight: '28px',
    fontWeight: _constants.FONT_WEIGHT.REGULAR
  },
  standardBody: {
    fontFamily: _constants.FONT_FACE.BODY,
    fontSize: fontSizes.small,
    lineHeight: lineHeights.medium,
    fontWeight: _constants.FONT_WEIGHT.REGULAR
  },
  smallBody: {
    fontFamily: _constants.FONT_FACE.BODY,
    fontSize: fontSizes.xsmall,
    lineHeight: lineHeights.small,
    fontWeight: _constants.FONT_WEIGHT.REGULAR
  },
  meta: {
    fontFamily: _constants.FONT_FACE.BODY,
    fontSize: fontSizes.xxsmall,
    lineHeight: '18px',
    fontWeight: _constants.FONT_WEIGHT.REGULAR
  },
  legal: {
    fontFamily: _constants.FONT_FACE.BODY,
    fontSize: fontSizes.xxxsmall,
    lineHeight: '17px',
    fontWeight: _constants.FONT_WEIGHT.REGULAR
  },
  disclaimer: {
    fontFamily: _constants.FONT_FACE.BODY,
    fontSize: fontSizes.xxxsmall,
    lineHeight: '13px'
  }
};
var weights = {
  ultraLight: 100,
  light: 300,
  regular: 400,
  semibold: 500,
  bold: 700,
  extraBold: 800
};
var coreOrange = {
  150: '#C85934',
  // deprecated
  125: '#E1643B',
  // deprecated
  100: '#FA6F41',
  75: '#FA916C',
  50: '#FBB398',
  25: '#FBD6C3',
  10: '#FCEADE'
};
var coreYellow = {
  150: '#CC8400',
  // deprecated
  125: '#E89703',
  // deprecated
  100: '#FFA500',
  75: '#FEBA3C',
  50: '#FECF78',
  25: '#FDE3B3',
  10: '#FCF0D7'
};
var coreMagenta = {
  100: '#DD66BB',
  75: '#E58AC8',
  50: '#ECAFD5',
  25: '#F4D4E2',
  10: '#F9E9EA'
};
var coreBlush = {
  100: '#FFF1EC',
  75: '#FEF3ED',
  50: '#FEF4ED',
  25: '#FDF6EE',
  10: '#FCF7EF'
};
var stirWhite = '#FFFFFF';
var coreWhite = {
  100: stirWhite,
  75: (0, _polished.transparentize)(0.75, stirWhite),
  50: (0, _polished.transparentize)(0.5, stirWhite),
  25: (0, _polished.transparentize)(0.25, stirWhite),
  10: (0, _polished.transparentize)(0.1, stirWhite),
  0: '#FCF8EF' // Stir Background/offwhite

};
var featureSuperblue = {
  150: '#12289A',
  // deprecated
  125: '#152DAD',
  // deprecated
  100: '#1732C0',
  75: '#5063CC',
  50: '#8995D7',
  25: '#C3C7E3',
  10: '#E5E4EA'
};
var functionalGold = {
  150: '#FDE3B3',
  // deprecated
  125: '#FDE3B3',
  // deprecated
  100: '#FDE3B3',
  75: '#FDEAC6',
  50: '#FEF1D9',
  25: '#FEF8EC',
  10: '#FFFCF7'
};
var functionalGreen = {
  150: '#54962F',
  // deprecated
  125: '#54962F',
  // deprecated
  100: '#54962F',
  75: '#7EAF5F',
  50: '#A8C78F',
  25: '#D2DFBF',
  10: '#EBEEDC'
};
var functionalRuby = {
  150: '#CC0429',
  // deprecated
  125: '#CC0429',
  // deprecated
  100: '#CC0429',
  75: '#D9435F',
  50: '#E58294',
  25: '#F2C0CA',
  10: '#FAE6EA'
};
var grays = {
  100: '#1D1C1C',
  75: '#555351',
  50: '#8D8A85',
  25: '#C4C1BA',
  10: '#E6E2DA',
  5: '#EDEDEE',
  0: '#FCF8EF'
};
var colors = {
  transparent: 'transparent'
};
var opacity = {
  100: 0,
  75: 0.25,
  50: 0.5,
  25: 0.75,
  10: 0.9,
  5: 0.95,
  0: 1
};
var designSystemColors = {
  core1_150: coreYellow[150],
  core1_125: coreYellow[125],
  core1_100: coreYellow[100],
  core1_75: coreYellow[75],
  core1_50: coreYellow[50],
  core1_25: coreYellow[25],
  core1_10: coreYellow[10],
  core1_75_opaque: (0, _polished.transparentize)(opacity[75], coreYellow[100]),
  core1_50_opaque: (0, _polished.transparentize)(opacity[50], coreYellow[100]),
  core1_25_opaque: (0, _polished.transparentize)(opacity[25], coreYellow[100]),
  core1_10_opaque: (0, _polished.transparentize)(opacity[10], coreYellow[100]),
  core2_150: coreMagenta[100],
  core2_125: coreMagenta[100],
  core2_100: coreMagenta[100],
  core2_75: coreMagenta[75],
  core2_50: coreMagenta[50],
  core2_25: coreMagenta[25],
  core2_10: coreMagenta[10],
  core2_75_opaque: (0, _polished.transparentize)(opacity[75], coreMagenta[100]),
  core2_50_opaque: (0, _polished.transparentize)(opacity[50], coreMagenta[100]),
  core2_25_opaque: (0, _polished.transparentize)(opacity[25], coreMagenta[100]),
  core2_10_opaque: (0, _polished.transparentize)(opacity[10], coreMagenta[100]),
  core3_150: coreOrange[150],
  core3_125: coreOrange[125],
  core3_100: coreOrange[100],
  core3_75: coreOrange[75],
  core3_50: coreOrange[50],
  core3_25: coreOrange[25],
  core3_10: coreOrange[10],
  core3_75_opaque: (0, _polished.transparentize)(opacity[75], coreOrange[100]),
  core3_50_opaque: (0, _polished.transparentize)(opacity[50], coreOrange[100]),
  core3_25_opaque: (0, _polished.transparentize)(opacity[25], coreOrange[100]),
  core3_10_opaque: (0, _polished.transparentize)(opacity[10], coreOrange[100]),
  core4_100: coreBlush[100],
  core4_75: coreBlush[75],
  core4_50: coreBlush[50],
  core4_25: coreBlush[25],
  core4_10: coreBlush[10],
  core4_75_opaque: (0, _polished.transparentize)(opacity[75], coreBlush[100]),
  core4_50_opaque: (0, _polished.transparentize)(opacity[50], coreBlush[100]),
  core4_25_opaque: (0, _polished.transparentize)(opacity[25], coreBlush[100]),
  core4_10_opaque: (0, _polished.transparentize)(opacity[10], coreBlush[100]),
  core5_100: coreWhite[100],
  core5_75: coreWhite[75],
  core5_50: coreWhite[50],
  core5_25: coreWhite[25],
  core5_10: coreWhite[10],
  core5_75_opaque: (0, _polished.transparentize)(opacity[75], coreWhite[100]),
  core5_50_opaque: (0, _polished.transparentize)(opacity[50], coreWhite[100]),
  core5_25_opaque: (0, _polished.transparentize)(opacity[25], coreWhite[100]),
  core5_10_opaque: (0, _polished.transparentize)(opacity[10], coreWhite[100]),
  feature1_150: featureSuperblue[150],
  feature1_125: featureSuperblue[125],
  feature1_100: featureSuperblue[100],
  feature1_75: featureSuperblue[75],
  feature1_50: featureSuperblue[50],
  feature1_25: featureSuperblue[25],
  feature1_10: featureSuperblue[10],
  feature1_75_opaque: (0, _polished.transparentize)(opacity[75], featureSuperblue[100]),
  feature1_50_opaque: (0, _polished.transparentize)(opacity[50], featureSuperblue[100]),
  feature1_25_opaque: (0, _polished.transparentize)(opacity[25], featureSuperblue[100]),
  feature1_10_opaque: (0, _polished.transparentize)(opacity[10], featureSuperblue[100]),
  functional1_150: functionalGreen[150],
  functional1_125: functionalGreen[125],
  functional1_100: functionalGreen[100],
  functional1_75: functionalGreen[75],
  functional1_50: functionalGreen[50],
  functional1_25: functionalGreen[25],
  functional1_10: functionalGreen[10],
  functional1_75_opaque: (0, _polished.transparentize)(opacity[75], functionalGreen[100]),
  functional1_50_opaque: (0, _polished.transparentize)(opacity[50], functionalGreen[100]),
  functional1_25_opaque: (0, _polished.transparentize)(opacity[25], functionalGreen[100]),
  functional1_10_opaque: (0, _polished.transparentize)(opacity[10], functionalGreen[100]),
  functional2_150: functionalRuby[150],
  functional2_125: functionalRuby[125],
  functional2_100: functionalRuby[100],
  functional2_75: functionalRuby[75],
  functional2_50: functionalRuby[50],
  functional2_25: functionalRuby[25],
  functional2_10: functionalRuby[10],
  functional2_75_opaque: (0, _polished.transparentize)(opacity[75], functionalRuby[100]),
  functional2_50_opaque: (0, _polished.transparentize)(opacity[50], functionalRuby[100]),
  functional2_25_opaque: (0, _polished.transparentize)(opacity[25], functionalRuby[100]),
  functional2_10_opaque: (0, _polished.transparentize)(opacity[10], functionalRuby[100]),
  functional3_150: functionalGold[150],
  functional3_125: functionalGold[125],
  functional3_100: functionalGold[100],
  functional3_75: functionalGold[75],
  functional3_50: functionalGold[50],
  functional3_25: functionalGold[25],
  functional3_10: functionalGold[10],
  functional3_75_opaque: (0, _polished.transparentize)(opacity[75], functionalGold[100]),
  functional3_50_opaque: (0, _polished.transparentize)(opacity[50], functionalGold[100]),
  functional3_25_opaque: (0, _polished.transparentize)(opacity[25], functionalGold[100]),
  functional3_10_opaque: (0, _polished.transparentize)(opacity[10], functionalGold[100]),
  gray_100: grays[100],
  gray_75: grays[75],
  gray_50: grays[50],
  gray_25: grays[25],
  gray_10: grays[10],
  gray_5: grays[5],
  gray_0: grays[0],
  gray_75_opaque: (0, _polished.transparentize)(opacity[75], grays[100]),
  gray_50_opaque: (0, _polished.transparentize)(opacity[50], grays[100]),
  gray_25_opaque: (0, _polished.transparentize)(opacity[25], grays[100]),
  gray_10_opaque: (0, _polished.transparentize)(opacity[10], grays[100]),
  gray_5_opaque: (0, _polished.transparentize)(opacity[5], grays[100]),
  gray_0_opaque: (0, _polished.transparentize)(opacity[0], grays[100])
};
var semanticGrays = {
  core1_100: grays[100],
  primary2: grays[75],
  primary3: '#6A6A6B',
  primary4: '#949495',
  primary5: '#BFBFBF',
  primary6: grays[10],
  secondary1: '#FAFAFA',
  secondary2: '#BABBBB',
  secondary3: '#8C8D8D',
  secondary4: '#5F5F60'
};
var semanticColors = {
  ctaPrimary: coreOrange[100],
  ctaSecondary: coreMagenta[100],
  focusPrimary: coreOrange[25],
  textPrimary: semanticGrays.primary2,
  textSecondary: '#6A6A6B',
  textTertiary: grays[50],
  error: functionalRuby[100],
  success: functionalGreen[100],
  warning: grays[100],
  info: coreOrange[100],
  link: coreOrange[100],
  disabled: grays[25],
  stroke: grays[10],
  transparent: colors.transparent,
  dark: grays[100],
  darkSubcopy: semanticGrays.primary2,
  darkTertiary: grays[50],
  darkGhost: grays[25],
  light: grays[0],
  lightSubcopy: (0, _polished.transparentize)(0.3, grays[0]),
  lightTertiary: (0, _polished.transparentize)(0.5, grays[0]),
  lightGhost: (0, _polished.transparentize)(0.7, grays[0])
};
var zIndex = {
  drawer: 1000,
  modal: 900,
  tooltip: 400,
  overlay: 300,
  nav: 200,
  subnav: 100
};

var palette = _objectSpread({}, grays, {}, semanticColors, {}, designSystemColors);

var dropShadows = {
  z0: "0 24px 48px 0 transparent",
  z1: '',
  z2: '',
  // leaving room for anything less than 70% transparency
  z3: "0 24px 48px 0 ".concat((0, _polished.transparentize)(0.7, grays[75])),
  z4: "0 12px 24px 0 ".concat((0, _polished.transparentize)(0.7, grays[75])),
  z5: ''
};
var radii = {
  corner: 0,
  roundCorner1x: 8,
  roundCorner2x: 16,
  round: 1000
};
var inputStates = (_inputStates = {
  outline: 0,
  lineHeight: lineHeights.small,
  color: palette.textPrimary,
  fontFamily: font.body,
  fontSize: fontSizes.small,
  ':hover': {
    background: palette.focusPrimary,
    borderColor: grays[75],
    ':focus': {
      background: 'inherit'
    }
  }
}, (0, _defineProperty2.default)(_inputStates, '@media (hover: none)', {
  ':hover': {
    background: 'inherit'
  }
}), (0, _defineProperty2.default)(_inputStates, ':focus', {
  borderColor: grays[75]
}), (0, _defineProperty2.default)(_inputStates, ':disabled', {
  background: semanticGrays.primary6,
  borderColor: semanticGrays.primary5,
  cursor: 'not-allowed'
}), (0, _defineProperty2.default)(_inputStates, '::placeholder', {
  color: semanticGrays.primary5
}), (0, _defineProperty2.default)(_inputStates, "error", {
  background: coreYellow[10],
  borderColor: coreMagenta[100],
  color: coreMagenta[100],
  outline: 0,
  ':focus, :hover': {
    borderColor: coreOrange[100],
    background: (0, _polished.transparentize)(0.9, coreOrange[100])
  },
  ':hover': {
    ':focus': {
      background: palette.functional1_10
    }
  }
}), (0, _defineProperty2.default)(_inputStates, "required", {}), (0, _defineProperty2.default)(_inputStates, "focus", {
  borderColor: grays[75]
}), (0, _defineProperty2.default)(_inputStates, "success", {
  outline: 0,
  background: palette.functional1_10,
  borderColor: palette.functional1_100,
  color: palette.functional1_100,
  ':focus, :hover': {
    borderColor: (0, _polished.transparentize)(0.5, palette.functional1_100),
    background: (0, _polished.transparentize)(0.9, palette.functional1_100)
  },
  ':hover': {
    ':focus': {
      background: (0, _polished.transparentize)(0.9, palette.functional1_100)
    }
  }
}), _inputStates);
/*
 * special case, because the new theme has so many inputs
 */

var inputVariants = {
  default: _objectSpread({
    border: "1px solid ".concat(semanticGrays.primary5),
    borderRadius: radii.roundCorner1x,
    padding: space.medium,
    transition: 'height .25s ease-out'
  }, inputStates),
  variant1: _objectSpread({}, inputStates, {
    background: semanticGrays.secondary1,
    border: 0,
    borderRadius: "".concat(radii.roundCorner1x, "px ").concat(radii.roundCorner1x, "px 0 0"),
    padding: "".concat(space.medium + 2, "px ").concat(space.medium, "px ").concat(space.medium - 2, "px"),
    borderBottom: "2px solid transparent"
  }),
  variant2: _objectSpread({}, inputStates, {
    border: 0,
    borderBottom: "1px dashed ".concat(palette.textPrimary),
    padding: "".concat(space.xsmall, "px ").concat(space.none, "px"),
    ':disabled': _objectSpread({}, inputStates[':disabled'], {
      background: 'inherit',
      ':focus, :hover': {
        fontWeight: weights.regular,
        borderColor: semanticGrays.primary5
      }
    }),
    error: _objectSpread({}, inputStates.error, {
      background: 'inherit',
      ':focus, :hover': {
        background: 'inherit',
        borderBottom: "1px solid"
      },
      ':hover': {
        ':focus': {
          background: 'inherit'
        }
      }
    }),
    ':focus, :hover': (0, _defineProperty2.default)({
      background: 'inherit',
      borderBottom: "1px solid ".concat(palette.core3_100)
    }, '::placeholder', {
      fontWeight: weights.regular
    }),
    required: {},
    success: _objectSpread({}, inputStates.success, {
      background: 'inherit',
      ':focus, :hover': {
        background: 'inherit',
        borderBottom: "1px solid"
      },
      ':hover': {
        ':focus': {
          background: 'inherit'
        }
      }
    })
  })
}; // const needs to be created just like this. The validate theme javascript
//  requires these format.

var components = {
  alert: {
    padding: space.medium,
    success: {
      border: "1px solid ".concat(palette.success),
      backgroundColor: "".concat((0, _polished.transparentize)(0.9, palette.success)),
      color: palette.success,
      iconColor: 'success'
    },
    error: {
      border: "1px solid ".concat(palette.error),
      backgroundColor: "".concat((0, _polished.transparentize)(0.9, palette.error)),
      color: palette.error,
      iconColor: 'error'
    },
    info: {
      border: "1px solid ".concat(palette.info),
      backgroundColor: "".concat((0, _polished.transparentize)(0.9, palette.info)),
      color: palette.info,
      iconColor: 'info'
    },
    warning: {
      border: "1px solid ".concat(palette.light),
      backgroundColor: palette.warning,
      color: palette.light,
      iconColor: 'light'
    }
  },
  ariaClickHandler: {
    disabled: {
      opacity: 0.3
    },
    enabled: (_enabled = {}, (0, _defineProperty2.default)(_enabled, ':focus', {
      outline: 'none',
      background: palette.focusPrimary,
      position: 'relative',
      boxShadow: "inset 0 0 0 1px ".concat((0, _polished.transparentize)(0.85, palette.core3_100))
    }), (0, _defineProperty2.default)(_enabled, '::-moz-focus-inner', {
      border: 0
    }), (0, _defineProperty2.default)(_enabled, ':focus:not(:focus-visible)', {
      background: 'inherit'
    }), (0, _defineProperty2.default)(_enabled, ':focus-visible', {
      background: (0, _polished.transparentize)(0.85, palette.core3_100),
      position: 'relative',
      boxShadow: "inset 0 0 0 1px ".concat((0, _polished.transparentize)(0.8, palette.core3_100))
    }), (0, _defineProperty2.default)(_enabled, ':hover', {
      position: 'relative',
      background: (0, _polished.transparentize)(0.95, palette.core3_100)
    }), _enabled)
  },
  badge: {
    backgroundColor: palette.core2_100,
    color: palette.light,
    defaults: function defaults(_ref) {
      var fontColor = _ref.fontColor;
      return {
        textAlign: 'center',
        borderRadius: '1.2em',
        color: fontColor,
        verticalAlign: 'middle',
        display: 'inline-block',
        fontFamily: font.body
      };
    },
    dot: function dot(_ref2) {
      var bgColor = _ref2.bgColor;
      return {
        background: bgColor,
        minWidth: '5px',
        minHeight: '5px',
        height: '5px',
        width: '5px',
        padding: '0px'
      };
    },
    icon: function icon() {
      return null;
    },
    iconPlacement: function iconPlacement(_ref3) {
      var iconMargin = _ref3.iconMargin;
      var marginLeft = iconMargin === 'left' ? '.25em' : 0;
      var marginRight = iconMargin === 'right' ? '.25em' : 0;
      return {
        marginLeft: marginLeft,
        marginRight: marginRight
      };
    },
    notification: function notification(_ref4) {
      var bgColor = _ref4.bgColor;
      return {
        background: bgColor,
        lineHeight: '1.1',
        padding: '2px',
        fontWeight: weights.bold,
        fontStyle: 'normal',
        fontSize: '10px',
        minWidth: '15px',
        height: '15px',
        boxSizing: 'border-box'
      };
    },
    indicatorPosition: {
      absolute: function absolute() {
        return {
          position: 'absolute',
          top: '-5px',
          right: '-5px'
        };
      },
      relative: function relative() {
        return {
          position: 'relative',
          top: 0,
          left: 0
        };
      }
    }
  },
  button: {
    defaults: function defaults(_ref5) {
      var _ref6;

      var primary = _ref5.primary,
          secondary = _ref5.secondary,
          circle = _ref5.circle;
      return _ref6 = {
        appearance: 'none',
        background: primary,
        borderColor: colors.transparent,
        borderRadius: circle ? radii.round : radii.roundCorner1x,
        borderStyle: 'solid',
        borderWidth: 1,
        color: secondary,
        cursor: 'pointer',
        fontFamily: font.body,
        fontSize: fontSizes.xsmall,
        fontWeight: weights.bold,
        textAlign: 'center',
        transition: "background 0.25s ease-out, color 0.25s ease-out",
        whiteSpace: 'nowrap'
      }, (0, _defineProperty2.default)(_ref6, '&:hover, &:focus', {
        outline: 'none',
        background: (0, _polished.lighten)(0.1, primary)
      }), (0, _defineProperty2.default)(_ref6, '&:visited', {
        color: secondary
      }), (0, _defineProperty2.default)(_ref6, '&:active', {
        background: (0, _polished.darken)(0.1, primary),
        color: secondary
      }), _ref6;
    },
    inverse: function inverse(_ref7) {
      var _ref8;

      var secondary = _ref7.secondary;
      return _ref8 = {
        borderColor: secondary
      }, (0, _defineProperty2.default)(_ref8, '&:hover, &:focus', {
        outline: 0,
        color: (0, _polished.lighten)(0.1, secondary),
        borderColor: (0, _polished.lighten)(0.1, secondary)
      }), (0, _defineProperty2.default)(_ref8, '&:active', {
        color: (0, _polished.darken)(0.1, secondary)
      }), _ref8;
    },
    ghost: function ghost(_ref9) {
      var _ref10;

      var primary = _ref9.primary,
          secondary = _ref9.secondary;
      return _ref10 = {
        background: colors.transparent,
        borderColor: primary,
        color: primary
      }, (0, _defineProperty2.default)(_ref10, ':hover, :focus', {
        outline: 0,
        color: secondary,
        background: primary,
        fill: secondary,
        svg: {
          fill: secondary
        }
      }), (0, _defineProperty2.default)(_ref10, ':active', {
        color: secondary
      }), (0, _defineProperty2.default)(_ref10, ':disabled, :disabled:hover', {
        opacity: 1,
        background: palette.transparent,
        borderColor: palette.disabled,
        color: palette.disabled,
        fill: palette.disabled
      }), (0, _defineProperty2.default)(_ref10, ':disabled svg', {
        fill: palette.disabled
      }), (0, _defineProperty2.default)(_ref10, "svg", {
        fill: primary
      }), _ref10;
    },
    minimal: function minimal(_ref11) {
      var _ref12;

      var secondary = _ref11.secondary;
      return _ref12 = {
        borderWidth: 0,
        background: colors.transparent,
        color: secondary
      }, (0, _defineProperty2.default)(_ref12, ':hover:not(:focus)', {
        background: (0, _polished.transparentize)(0.45, palette.gray_5)
      }), (0, _defineProperty2.default)(_ref12, ':active', {
        background: (0, _polished.transparentize)(0.25, palette.gray_5)
      }), (0, _defineProperty2.default)(_ref12, ':focus', {
        position: 'relative',
        background: (0, _polished.transparentize)(0.45, palette.gray_5),
        boxShadow: "0 0 0 1px ".concat(palette.gray_50),

        /* Visible in Windows high-contrast themes */
        outlineColor: 'transparent',
        outlineWidth: 2,
        outlineStyle: 'dotted'
      }), (0, _defineProperty2.default)(_ref12, ':disabled:hover', {
        background: palette.transparent
      }), _ref12;
    },
    disabled: function disabled(_ref13) {
      var _ref14;

      var minimal = _ref13.minimal,
          primary = _ref13.primary,
          secondary = _ref13.secondary,
          inverse = _ref13.inverse;
      return _ref14 = {
        background: minimal ? colors.transparent : (0, _polished.mix)(0.3, primary, '#fff'),
        borderColor: inverse ? (0, _polished.mix)(0.3, secondary, '#fff') : colors.transparent,
        color: (0, _polished.mix)(0.3, secondary, '#fff'),
        boxShadow: 'none',
        cursor: 'not-allowed'
      }, (0, _defineProperty2.default)(_ref14, '&:hover', {
        background: minimal ? colors.transparent : (0, _polished.mix)(0.3, primary, '#fff'),
        borderColor: inverse ? (0, _polished.mix)(0.3, secondary, '#fff') : colors.transparent,
        color: (0, _polished.mix)(0.3, secondary, '#fff')
      }), (0, _defineProperty2.default)(_ref14, '&:active', {
        background: (0, _polished.mix)(0.3, primary, '#fff'),
        borderColor: inverse ? (0, _polished.mix)(0.3, secondary, '#fff') : colors.transparent,
        color: (0, _polished.mix)(0.3, secondary, '#fff')
      }), (0, _defineProperty2.default)(_ref14, ':disabled svg', {
        fill: (0, _polished.mix)(0.3, secondary, '#fff')
      }), _ref14;
    },
    sizes: {
      small: {
        height: 24,
        fontSize: fontSizes.xxsmall,
        paddingRight: space.small,
        paddingLeft: space.small
      },
      medium: {
        height: 32,
        fontSize: fontSizes.xsmall,
        paddingRight: space.medium,
        paddingLeft: space.medium
      },
      large: {
        height: 40,
        fontSize: fontSizes.small,
        paddingRight: space.medium,
        paddingLeft: space.medium
      },
      slarge: {
        height: 48,
        fontSize: fontSizes.small,
        paddingRight: space.medium,
        paddingLeft: space.medium
      },
      xlarge: {
        height: 56,
        fontSize: fontSizes.medium,
        paddingRight: space.large,
        paddingLeft: space.large
      }
    },
    circle: {
      xsmall: 32,
      small: 40,
      medium: 48,
      large: 56,
      xlarge: 64
    }
  },
  checkbox: {
    icon: 'check',
    iconSize: 6,
    width: 24,
    height: 24,
    borderRadius: "4px",
    rowSpace: space.xsmall,
    label: {
      space: space.small
    },
    checked: {
      border: "1px solid ".concat(palette.core3_100),
      color: 'light',
      backgroundColor: palette.core3_100
    },
    unchecked: {
      border: "1px solid ".concat(palette.gray_25)
    },
    focused: {
      border: "1px solid ".concat(palette.core3_25),
      boxShadow: "0 0 0px 4px ".concat(palette.core3_25)
    },
    hover: {
      border: "1px solid ".concat(palette.core3_100),
      boxShadow: "0",
      backgroundColor: palette.core3_25
    },
    disabled: {
      opacity: 0.3
    }
  },
  drawer: {
    borderRadius: radii.roundCorner2x
  },
  floatingPlaceholder: {
    default: {
      color: palette.gray_50,
      hoverColor: palette.core3_100,
      focusColor: palette.core3_100
    },
    error: {
      color: coreMagenta[100],
      hoverColor: coreOrange[100],
      focusColor: coreOrange[100]
    },
    success: {
      color: palette.functional1_100,
      hoverColor: palette.functional1_100,
      focusColor: palette.functional1_100
    }
  },
  icon: {
    prefix: 'stir-',
    size: iconSizes,
    url: function url() {
      return (0, _interpolateDefaultRequire.default)(require('./static/theme-icons.svg'));
    } // Requires webpack file loader

  },
  image: {
    color: {
      background: palette.stroke
    },
    shape: {
      square: {
        borderRadius: 0
      },
      roundCorner1x: {
        borderRadius: "".concat(radii.roundCorner1x, "px")
      },
      roundCorner2x: {
        borderRadius: "".concat(radii.roundCorner2x, "px")
      },
      round: {
        borderRadius: '100%'
      }
    },
    defaultImage: function defaultImage() {
      return (0, _interpolateDefaultRequire.default)(require('./static/theme-silhouette.svg'));
    }
  },
  input: _objectSpread({}, inputVariants),
  loading: {
    colorName: 'core3_100',
    defaultIcon: '',
    sizes: {
      xxsmall: {
        width: 32,
        stroke: 1
      },
      xsmall: {
        width: 48,
        stroke: 2
      },
      small: {
        width: 64,
        stroke: 2
      },
      medium: {
        width: 80,
        stroke: 3
      },
      large: {
        width: 96,
        stroke: 4
      }
    },
    colors: {
      color1: palette.core3_100,
      color2: coreOrange[100],
      color3: palette.core3_100,
      color4: coreOrange[100]
    },
    mask: {
      backgroundColor: palette.disabled,
      opacity: 0.5
    }
  },
  logo: {
    url: function url() {
      return (0, _interpolateDefaultRequire.default)(require('./static/theme-logo.svg'));
    }
  },
  modal: {
    config: {
      standardMargin: space.none,
      scrollingModalMargin: space.xxlarge,
      zIndex: zIndex.modal,
      paddingY: space.xxlarge,
      paddingX: '2%',
      borderRadius: radii.roundCorner1x
    },
    ui: {
      backgroundColor: palette.light,
      border: 0,
      borderRadius: radii.roundCorner1x,
      ':focus': {
        outline: 'none'
      },
      '::-moz-focus-inner': {
        border: 0
      }
    },
    closeButton: {
      alignItems: 'center',
      borderRadius: radii.round,
      display: 'flex',
      height: iconSizes.small,
      justifyContent: 'center',
      width: iconSizes.small,
      marginLeft: space.small
    }
  },
  radio: {
    width: 24,
    height: 24,
    borderRadius: "".concat(radii.round, "px"),
    rowSpace: space.xsmall,
    label: {
      space: space.small
    },
    checked: {
      border: "2px solid ".concat(palette.core3_100),
      backgroundColor: palette.light
    },
    checkedDot: {
      width: 12,
      height: 12,
      border: "0px",
      backgroundColor: palette.core3_100
    },
    unchecked: {
      border: "2px solid ".concat(palette.core3_100),
      backgroundColor: palette.light
    },
    focused: {
      boxShadow: "0 0 0px 4px ".concat(palette.core3_25)
    },
    hover: {
      color: palette.core1_100,
      boxShadow: "0 0 0px 4px ".concat(palette.focusPrimary),
      backgroundColor: palette.core3_10
    },
    disabled: {
      opacity: 0.5
    }
  },
  select: {
    borderColor: palette.stroke,
    focus: {
      backgroundColor: palette.focusPrimary
    },
    selected: {
      color: palette.core1_100 // backgroundColor: palette.focusPrimary,

    },
    dropdown: {
      borderRadius: "".concat(radii.roundCorner1x, "px"),
      backgroundColor: palette.light,
      boxShadow: "0 10px 30px 8px ".concat(palette.stroke),
      minWidth: 150
    },
    error: {
      borderColor: palette.error
    },
    hasSelection: {
      borderColor: palette.core1_100
    },
    color: palette.textPrimary
  },
  slider: {
    size: 24,
    track: {
      size: 4,
      offset: 12,
      backgroundColor: palette.core3_100,
      borderRadius: "".concat(radii.roundCorner1x, "px"),
      disabled: {
        backgroundColor: palette.disabled
      }
    },
    rail: {
      size: 4,
      backgroundColor: palette.stroke,
      borderRadius: "".concat(radii.roundCorner1x, "px"),
      disabled: {
        backgroundColor: palette.stroke
      }
    },
    handle: {
      border: 'none',
      borderRadius: "".concat(radii.round, "px"),
      width: 24,
      height: 24,
      leftOffset: -12,
      topOffset: -10,
      backgroundColor: palette.light,
      boxShadow: "0 2px 8px 0 ".concat((0, _polished.transparentize)(0.8, palette.dark)),
      focus: {
        border: "0px solid ".concat((0, _polished.darken)(0.7, palette.dark)),
        boxShadow: "0 0 8px 2px ".concat((0, _polished.transparentize)(0.7, palette.core3_100))
      },
      hover: {
        border: "0px solid ".concat((0, _polished.lighten)(0.7, palette.dark)),
        boxShadow: "0 0 8px 2px ".concat((0, _polished.transparentize)(0.7, palette.core3_100))
      },
      active: {
        border: "0px solid ".concat((0, _polished.darken)(0.7, palette.dark)),
        boxShadow: "0 0 8px 2px ".concat((0, _polished.transparentize)(0.7, palette.core3_100))
      },
      disabled: {
        backgroundColor: palette.stroke,
        boxShadow: 'none',
        borderColor: palette.stroke
      }
    },
    mark: {
      color: palette.textTertiary,
      offset: 32,
      active: {
        color: palette.core3_100
      }
    },
    step: {
      size: 4,
      offset: 12,
      backgroundColor: 'none'
    },
    dot: {
      width: 8,
      height: 8,
      yOffset: -2,
      xOffset: -4,
      border: "2px solid ".concat(palette.stroke),
      backgroundColor: palette.stroke,
      borderRadius: "".concat(radii.round, "px"),
      active: {
        borderColor: palette.core3_100,
        backgroundColor: palette.core3_100
      },
      disabled: {
        backgroundColor: palette.disabled,
        boxShadow: 'none',
        borderColor: palette.stroke
      }
    }
  },
  switch: {
    sizes: {
      small: {
        height: 24,
        width: 40
      },
      medium: {
        height: 32,
        width: 56
      }
    },
    borderRadius: "".concat(radii.round, "px"),
    on: {
      backgroundColor: palette.core3_100,
      border: "2px solid ".concat(palette.core3_100)
    },
    off: {
      backgroundColor: palette.stroke,
      border: "2px solid ".concat(palette.stroke)
    },
    slider: {
      sizes: {
        small: {
          height: 24,
          width: 24
        },
        medium: {
          height: 32,
          width: 32
        }
      },
      borderRadius: "".concat(radii.round, "px"),
      boxShadow: "-1px 1px 2px ".concat((0, _polished.transparentize)(0.7, palette.dark)),
      backgroundColor: palette.light
    },
    focused: {
      boxShadow: "0px 0px 0px 4px ".concat(palette.core3_100),
      border: "2px solid ".concat(palette.light)
    },
    disabled: {
      opacity: 0.3
    }
  },
  overlay: {
    color: {
      dark: palette.dark,
      light: palette.light
    },
    zIndex: zIndex.overlay
  },
  textArea: {
    default: _objectSpread({}, inputVariants.default),
    noResize: {
      resize: 'none'
    },
    singleLine: {
      paddingBottom: 0
    },
    variant1: inputVariants.variant1
  }
};
var breakPoints = [320, 410, 768, 1140];
var background = coreWhite[0];
var theme = {
  background: background,
  branding: branding,
  breakPoints: breakPoints,
  components: components,
  dropShadows: dropShadows,
  font: font,
  fontSizes: fontSizes,
  fontVariants: fontVariants,
  iconScale: iconScale,
  iconSizes: iconSizes,
  lineHeights: lineHeights,
  opacity: opacity,
  palette: palette,
  radii: radii,
  space: space,
  typography: typography,
  weights: weights,
  zIndex: zIndex
};
var _default = theme;
exports.default = _default;